import dynamic from "next/dynamic";

export const TeamFeed = dynamic(() => import("./component"));
